import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-page",
  "use": "icon-page-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-page\">\r\n<path d=\"M114.7,28.8L91.3,5.3C90.5,4.5,89.4,4,88.2,4H20.9c-4.8,0-8.6,3.9-8.6,8.6v103.7c0,4.8,3.9,8.6,8.6,8.6h86.4\r\n\tc4.8,0,8.6-3.9,8.6-8.6V31.8C115.9,30.7,115.5,29.6,114.7,28.8z M107.3,112c0,2.4-1.9,4.3-4.3,4.3H25.2c-2.4,0-4.3-1.9-4.3-4.3V17\r\n\tc0-2.4,1.9-4.3,4.3-4.3H77v21.6c0,4.8,3.9,8.6,8.6,8.6h21.6V112z M90,34.3c-2.4,0-4.3-1.9-4.3-4.3V12.6l21.6,21.6H90z\" />\r\n<path d=\"M85.5,86.1H33.7c-2.4,0-4.3,1.9-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3h51.9c2.4,0,4.3-1.9,4.3-4.3C89.9,88,87.9,86.1,85.5,86.1z\r\n\t M33.7,60.2c-2.4,0-4.3,1.9-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3h51.9c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3H33.7z M33.7,42.9h25.9\r\n\tc2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3H33.7c-2.4,0-4.3,1.9-4.3,4.3C29.4,41,31.3,42.9,33.7,42.9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/page.svg
// module id = zrC5
// module chunks = 113